import moment from 'moment';

import axios from 'utils/axios';

// Goal periods are resolved on the server (Eastern): the client names a period,
// it never computes the window. `period` is one of day | week | month | month-to-yesterday.
export async function getGoalProgressForUser(userId, period) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/user/${userId}/productivity-goal-day/progress`, {
            params: { period }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

// The user's derived goal and logged seconds for every day of a month (YYYY-MM).
// Omit the month for the server's current month in the org zone; the response
// carries `today` so the caller never resolves the date itself.
export async function getMonthGoalProgressForUser(userId, month) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/user/${userId}/productivity-goal-day/month`, {
            params: { month }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getMonthlyInteractionsForLoggedInUser() {
    // the current calendar month in browser-local time, half-open [fromTS, toTS)
    const fromTS = moment().startOf('month').valueOf();
    const toTS = moment().startOf('month').add(1, 'month').valueOf();
    try {
        const response = await axios.get(`/api/org-id/{orgId}/productivity/care-stats/monthly-interactions`, {
            params: {
                fromTS,
                toTS
            }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
